import React from 'react';
import styled from 'styled-components';
import { fontStyle, themeLight, spacing } from '../../../theme/index';
import { Error } from '@styled-icons/material/Error';
export const Message = ({ children, error = true, className }) => {
    return (<FormMessage className={className} error={error}>
      {error && <Error size={16}/>}
      {children}
    </FormMessage>);
};
export default Message;
const FormMessage = styled.span `
  ${fontStyle.bodyText.small};
  flex-basis: 100%;
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.componentColors ? theme.componentColors.alert.error : themeLight.componentColors.alert.error};

  svg {
    padding-right: ${spacing.space8};
  }
`;
